const binding = { modules: {}, dataActions: {} };

    (binding.modules['modal-container'] = {
        c: () => require('partner/modules/modal-container/modal-container.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'modal-container',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/modal-container'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };